import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {Link} from 'react-router';

import withI18n from 'spa/Components/Context/withI18n';

@observer
@withI18n
class AccountDetails extends React.Component {
  static propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string.isRequired,
    }).isRequired,
  };

  UNSAFE_componentWillMount() {
    const {name} = this.props.user;

    if (name) {
      const namesList = name.trim().split(' ');

      let initials = namesList[0][0];

      if (namesList.length > 1) {
        initials += namesList[namesList.length - 1][0];
      }

      this.userInitials = initials;
    }
  }

  render() {
    const {user} = this.props;
    if (!user) return null;
    const {i18n} = this.context;

    return (
      <Link className="site-header-col site-header-col--account" data-qa="header-account-button" to={`/${i18n.lc}/account/bookings`}>
        <span className="site-header-col--account-text" data-qa="header-account-button-text">{i18n.__('My Account')}</span>
        <span className="site-header-col--account-initials">{this.userInitials}</span>
      </Link>
    );
  }
}

export default AccountDetails;



// WEBPACK FOOTER //
// ./spa/Components/Header/AccountDetails.jsx